var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full pb-10" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.projectData.loading,
            hasData: !!_vm.project,
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col xl:flex-col mb-2 sm:mb-0 w-full" },
            [
              _c(
                "div",
                { staticClass: "flex flex-col xl:flex-row gap-4" },
                [
                  _c("ProjectHeader", {
                    attrs: {
                      project: _vm.project,
                      phoneNumber: _vm.initialProject?.phone_number,
                      userRole: _vm.currentUser.role,
                      currentUser: _vm.currentUser,
                    },
                    on: {
                      updateProjectStatus: _vm.updateProjectStatus,
                      edit: _vm.enableEditMode,
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "bg-white rounded-lg shadow-md document-sec",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "border-b border-gray-200 px-3 pt-4 pb-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-mb-px flex flex-row justify-between",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "whitespace-no-wrap pb-1 border-b-2 border-transparent font-semibold text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300 hover:text-gray-700 hover:border-secondary-black",
                                  attrs: { href: "#" },
                                },
                                [_vm._v(" Client documents ")]
                              ),
                              _c(
                                "router-link",
                                {
                                  staticClass: "customTextStyle",
                                  attrs: {
                                    to: `/clients_visit/${_vm.project.id}/documents`,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.handleViewAllClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" View all ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("ProjectDocumentsSideBar", {
                        attrs: {
                          projectCompleted: _vm.project.completed,
                          projectId: _vm.project.id,
                          userRole: _vm.currentUser.role,
                          currentUser: _vm.currentUser,
                          companyId: _vm.company.id,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "mb-2 sm:mb-0 gap-6 w-full relative" },
            [
              _c("TabsWithRoutes", {
                staticClass: "capitalize bg-white mt-7 routeBlock",
                attrs: { routeTabs: _vm.routeTabs },
                on: { tabChanged: _vm.refetchTabData },
                scopedSlots: _vm._u(
                  [
                    {
                      key: _vm.routes.PROJECT_ACTIVITY,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v(" Visits "),
                              ]),
                              _vm.projectData.activitiesCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification:
                                        _vm.projectData.activitiesCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.hasUnconfirmedHours
                                ? _c("ActivityHoursUnconfirmedAlert", {
                                    attrs: {
                                      iconClasses: "inline h-5 w-5",
                                      title:
                                        "One or more task has hours requested by a contractor, but working hours have not yet been approved",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_ACTIVITY_EMPTY,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("Open visits"),
                              ]),
                              _vm.projectData.emptyactivitiesCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification:
                                        _vm.projectData.emptyactivitiesCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_DETAILS,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v(" Details "),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_NOTES,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("Notes"),
                              ]),
                              _vm.projectData.notesCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification: _vm.projectData.notesCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_CONTRACTORS,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("Resources"),
                              ]),
                              _vm.projectData.contractorsCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification:
                                        _vm.projectData.contractorsCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_REQUESTS,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v(" Talent hunt "),
                              ]),
                              _vm.projectData.requestsCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification:
                                        _vm.projectData.requestsCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_GROUPS,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("Groups"),
                              ]),
                              _vm.projectData.groupsCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification: _vm.projectData.groupsCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_TIME_TRACKED,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v("Logged hours"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_DOCUMENTS,
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "flex items-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v(" Documents "),
                              ]),
                              _vm.projectData.documentsCount
                                ? _c("TabNotificationBubble", {
                                    attrs: {
                                      notification:
                                        _vm.projectData.documentsCount,
                                      info: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_CLIENT,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v(" Client Profile "),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: _vm.routes.PROJECT_CARE_PLAN,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "flex items-end" }, [
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v(" Care Plan "),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _c("router-view", {
            attrs: {
              description: _vm.projectDescription,
              project: _vm.project,
              userRole: _vm.currentUser.role,
              company: _vm.company,
              companyId: _vm.company.id,
              projectId: _vm.projectId,
              projectCompleted: _vm.projectCompleted,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
              projectSkills: _vm.projectSkills,
            },
            on: {
              documentsListChanged: _vm.updateDocumentsCount,
              activityListChanged: _vm.refetchProject,
            },
          }),
        ],
        1
      ),
      _vm.dialog
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.dialog,
              companyId: _vm.company.id,
              currentUser: _vm.currentUser,
              activeTab: _vm.activeTab,
              isCareplanExist: _vm.isCareplanExist,
              initialData: _vm.initialProject,
              isEdit: true,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }